import { render, staticRenderFns } from "./CollectListSearchLayout.vue?vue&type=template&id=212f0d5c&scoped=true&"
import script from "./CollectListSearchLayout.vue?vue&type=script&lang=js&"
export * from "./CollectListSearchLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212f0d5c",
  null
  
)

export default component.exports